import { UAParser } from "ua-parser-js";
import English from "./locale/en.js";

export default {
  data() {
    return {
      locales: {
        en: English,
      },
    };
  },
  methods: {
    getName() {
      let name = (this.$store.state.info.first_name || "").toLowerCase();
      return name.replace(/\b\w/g, (char) => char.toUpperCase());
    },
    getMediaPath(path) {
      return process.env.VUE_APP_MEDIA_URL + "images" + path;
    },
    getAsset(path = "", file_name) {
      return process.env.VUE_APP_CDN_URL + path + "/" + file_name;
    },
    lang(id, lang = null) {
      let store = this.$store.state,
        language = lang || store.lang,
        locale = this.locales[language],
        keys = Object.keys(locale);

      if (keys.indexOf(id) !== -1) {
        return locale[id];
      }

      return id;
    },
    getTitleCase(string) {
      if (!string) return "";
      return string.replace(
        /\w\S*/g,
        (txt) => txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase(),
      );
    },
    setUserAgent(userAgent) {
      let ua = new UAParser(userAgent),
        state = this.$store.state;

      state.user_agent.browser.name = ua.getBrowser().name;
      state.user_agent.browser.version = ua.getBrowser().version;
      state.user_agent.device.model = ua.getDevice().model;
      state.user_agent.device.type = ua.getDevice().type;
      state.user_agent.device.vendor = ua.getDevice().vendor;
      state.user_agent.engine.name = ua.getEngine().name;
      state.user_agent.engine.version = ua.getEngine().version;
      state.user_agent.os.name = ua.getOS().name;
      state.user_agent.os.version = ua.getOS().version;
    },
    setUserData(data) {
      let state = this.$store.state;
      let ga_mode = process.env.VUE_APP_ELECTION_ENABLED.toString() == "true";

      state.login = true;
      state.uuid = data.uuid;
      state.key = data.key;
      state.qr = data.qr;
      state.hash = data.hash;
      state.active = data.active;
      state.has_pin = data.has_pin;
      state.express = data.express;
      state.deactivate_date = data.deactivated;
      state.deactivated = state.deactivate_date != null;
      state.config = data.config;
      state.pin_update = data.pin_update;
      state.pso_enroll = data.pso_enroll;
      state.info.first_name = data.info.first_name;
      state.info.last_name = data.info.last_name;
      state.info.middle_name = data.info.middle_name;
      state.info.account_no = data.info.account_number;
      state.info.serial_no = data.info.serial_number;
      state.info.username = data.info.username;
      state.info.membership_type = data.info.membership_type;
      state.info.regular = data.info.regular;
      state.info.mobile_no = data.info.mobile;
      state.info.email = data.info.email;
      state.info.tin = data.info.tin;
      state.info.date_of_birth = data.info.date_of_birth;
      state.info.age = data.info.age;
      state.info.gender = data.info.gender;
      state.info.registered = data.info.registered;
      state.ledgers.balances = Object.entries(data.balances).map(
        ([code, value]) => ({
          code,
          total_balance: value.total_balance,
          total_records: value.total_records,
          as_of: value.as_of,
        }),
      );

      if (ga_mode) {
        state.ga.user.can_participate = data.ga.can_participate;
        state.ga.user.has_participated = data.ga.has_participated;
        state.ga.user.has_registered = data.ga.has_registered;
      }
    },
    resetUserData() {
      let state = this.$store.state;

      state.login = false;
      state.uuid = null;
      state.key = null;
      state.qr = null;
      state.hash = null;
      state.active = false;
      state.has_pin = false;
      state.express = false;
      state.deactivate_date = null;
      state.deactivated = false;
      state.pin_update = false;
      state.pso_enroll = false;
      state.pin_login = false;
      state.otp_login = false;
      state.temp_pin = null;
      state.forgot_pin = false;
      state.info.first_name = null;
      state.info.last_name = null;
      state.info.middle_name = null;
      state.info.account_no = null;
      state.info.serial_no = null;
      state.info.username = null;
      state.info.membership_type = null;
      state.info.regular = false;
      state.info.mobile_no = null;
      state.info.email = null;
      state.info.tin = null;
      state.info.date_of_birth = null;
      state.info.age = null;
      state.info.gender = null;
      state.info.registered = null;
      state.info.deactivated = false;
      state.info.deactivate_date = null;
      state.config = [];
      state.reset_pin = {
        otp_token: null,
        otp_pin: null,
      };
      state.enroll = {
        pin: null,
        email: null,
        mobile_no: null,
        tin: null,
        date_of_birth: null,
      };
      state.fun_run = {
        run_key: "",
        run_year: "",
        event_name: "",
        event_date: "",
        event_location: "",
        has_started: false,
        has_ended: false,
        registration_start: "",
        registration_end: "",
        is_editing: false,
        registrants: [],
        segments: [],
      };
    },
    makeCookie(hash, expire) {
      if (!this.$cookies.isKey("hash")) {
        this.$cookies.set("hash", hash, expire ? 60 * 60 * 24 : 0);
      }
    },
    makePINLoginCookie(hash) {
      if (!this.$cookies.isKey("pin_login")) {
        this.$cookies.set("pin_login", hash);
      }
    },
    makeOTPLoginCookie(hash) {
      if (!this.$cookies.isKey("otp_login")) {
        this.$cookies.set("otp_login", hash);
      }
    },
    makeSkipCookie(hash) {
      if (!this.$cookies.isKey("skipped_update")) {
        this.$cookies.set("skipped_update", hash);
      }
    },
    destroyCookies() {
      const hash = this.$cookies.get("hash");
      const cookie_keys = ["pin_login", "otp_login", "skipped_update"];
      if (hash) {
        this.$cookies.remove("hash");
        cookie_keys.forEach((key) => {
          if (this.$cookies.get(key) === hash) {
            this.$cookies.remove(key);
          }
        });
      }
    },
    parseDate(date) {
      return new Date(date) ? new Date(date.replace(" ", "T")) : null;
    },
    setTitleText(text) {
      if (!text) return text;

      return text
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },
    formatDate(date_value) {
      if (!date_value) return "";

      const date_obj = new Date(date_value);

      return new Intl.DateTimeFormat("en-PH", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
      }).format(date_obj);
    },
    formatShortDate(date_value) {
      if (!date_value) return "";

      const date = new Date(date_value);

      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const year = date.getFullYear();

      return `${month}/${day}/${year}`;
    },
    getImage(path, file_name) {
      if (process.env.VUE_APP_CDN_URL) {
        return process.env.VUE_APP_CDN_URL + path + file_name;
      }
    },
    getAccountDescription(code) {
      const descriptions = {
        SAV: "Regular Savings Deposit is your primary savings account where you can securely save money while earning dividends and maintaining membership standing.",
        SSD: "Special Savings Deposit is a higher-yield savings account designed to help members grow their savings faster through competitive dividend earnings.",
        SHR: "Share Capital represents your ownership contribution to the cooperative and serves as one of the requirements for maintaining active membership.",
        D06: "Salary Loan covers medium to large expenses intended for house repairs and other financial needs.",
        D07: "Emergency Loan provides immediate financial assistance during urgent or unexpected situations requiring quick access to funds.",
        D09: "This provides immediate loan assistance to members affected by calamities.",
        D14: "This covers procurement of durable items such as but not limited to furniture, appliances, and other equipment.",
        D18: "This is intended to support the education needs of members or their dependents.",
        D19: "This is intended for the acquisition of house and lot, condominium units, and other real estate properties or for house repair/renovation of an existing unit.",
        D30: "This covers capital and other expenses related to livelihood or income-generating projects.",
        D36: "Petty Cash Loan covers small expenses and bills.",
        D44: "Back-to-back loan uses a member’s Regular Savings Deposit (RSD), Time Deposit (TD), and/or Share Capital (SC) as collateral.",
        D50: "This is intended to help members cover transportation and commuting-related expenses, providing convenient financial support for daily travel needs.",
        D52: "Multi-Purpose Loan is a flexible loan product that can be used for personal, educational, medical, or other financial needs.",
        D53: "This is intended for the acquisition of new and pre-owned vehicles for personal or commercial/business use.",
        D54: "This is intended for travel and leisure expenses, education-related expenses, minor house repairs, utility bills, and others.",
      };

      return descriptions[code] || "No description available.";
    },
  },
};
